<template>
  <div id="action_container">
    <h1>RSVP with <br> 1 Click</h1>
    <div class="actions">
    <FontAwesomeIcon icon="check" size="2x" />
      <h2>Save your spot for our North Carolina State Lobby Day!</h2>
      <AppButton class="action_buttons" btnSrc="https://act.yourethecure.org/ddJuIdh">RSVP</AppButton>
    </div>
    <div  class="actions">
        <FontAwesomeIcon :icon="['far', 'envelope']" size="2x" class="icons"/>
        <h2>Share your story!</h2>
         <AppButton class="action_buttons" btnSrc="https://act.yourethecure.org/itqCwiD">SEND LETTER</AppButton>
    </div>
    <div class="actions">
        <FontAwesomeIcon :icon="['fab', 'twitter']" size="2x" class="icons"/>
        <h2>Tweet your rep!</h2>
        <AppButton class="action_buttons" btnSrc=" https://act.yourethecure.org/Jqxc5sK">TWEET</AppButton>
    </div> 
  </div>
</template>

<script>
import AppButton from './AppButton'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faTwitter,
  faEnvelope,
  faCheck
)

export default {
  components: {
      AppButton,
      FontAwesomeIcon
  }
};
</script>

<style>

#action_container > div:nth-child(2) > a > button {
  background-color: #C10D21;
  color: #ffffff;
}

#action_container > div:nth-child(3) > a > button {
  background-color: #C10D21;
  color: #ffffff;
}

#action_container > div:nth-child(4) > a > button {
  background-color: #C10D21; 
  color: #ffffff; 
}

#action_container {
    width: 30rem;
    height: 50rem;
    margin-left: 5rem;
    margin-bottom: 5rem;
    margin-right: 1rem;
    border: 1px; 
    border-style: groove;
    background-color: #FAFAFA;
}

.icons {
     margin-top: 2rem;  
}

.action_buttons {
  margin: auto;
  display: flex;
  justify-content: center;
}

.actions {
  padding: 0.5rem;
}

@media (min-width: 1024px) {
  #action_container {
    margin-left: 2rem;
  }
}

@media (max-width: 768px) {
  #action_container {
    margin: 0;
    width: 100%;
  }
}
</style>
